import TimeInfoCard from "components/ArticleOrder/status/ComitteeAskSupervisorForm/TimeInfoCard";
import { useParams } from "react-router-dom";

import AfterCopyrightDecisionForm from "./AfterCopyrightDecisionForm";

function SendToSupervisorComponent() {
  const { offerID, committee, status } = useParams();
  return (
    <AfterCopyrightDecisionForm
      offerID={offerID}
      committee={committee}
      status={status}
      beforeMediaUploadNode={<TimeInfoCard offerID={offerID} />}
    />
  )
}
export default SendToSupervisorComponent;